'use client';
/** @jsxImportSource @emotion/react */

import * as React from 'react';
import { type SVGProps } from 'react';
const Subtract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Subtract_svg__a)">
      <path d="M19 13H5v-2h14v2Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="Subtract_svg__a">
        <path d="M0 0h24v24H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default Subtract;
